import AggregateEditor from './AggregateEditor'

export default AggregateEditor
